const LoginFormMessages = {
  FormH1: 'Ingreso',
  placeHolderInput1: 'Correo electrónico',
  placeHolderInput2: 'Contraseña',
  textButton: 'Acceder',
  recoveryText: '¿Olvidaste tu contraseña?'
}

export default LoginFormMessages
